export default "__VITE_ASSET__BM6y88Rk__"